import { useCallback, useEffect, useMemo, useState } from 'react';

const useIsConsentBannerLoaded = () => {
  const {
    0: isBannerLoaded,
    1: setIsBannerLoaded
  } = useState(true && !!window.OneTrust);
  const handleBannerLoaded = useCallback(() => {
    setIsBannerLoaded(true);
  }, []);
  useEffect(() => {
    window.addEventListener('bannerLoaded', handleBannerLoaded);
    return () => {
      window.removeEventListener('bannerLoaded', handleBannerLoaded);
    };
  }, [handleBannerLoaded]);
  return useMemo(() => isBannerLoaded, [isBannerLoaded]);
};

export default useIsConsentBannerLoaded;